module.exports = __webpack_public_path__ + "img/portrait-005.8ae53ff6.jpg";